import { NgModule, LOCALE_ID } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { AppRouteReuseStrategy } from './core/strategies/app-route-reuse.strategy';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';

// Core modules
import { CoreModule } from './core/core.module';

// Ng-Zorro
import { NgZorroModule } from './shared/ng-zorro/ng-zorro.module';

// Routing
import { AppRoutingModule } from './app-routing.module';

// Components
import { AppComponent } from './app.component';

import { JiraControlModule } from './jira-control/jira-control.module';
import { SnowModule } from './core/snow/snow.module';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

// Register locale
registerLocaleData(localeIt, 'it');

@NgModule({
  declarations: [AppComponent],
  imports: [
    // Angular Core
    BrowserModule,
    BrowserAnimationsModule,

    // Core (singleton services e app init)
    CoreModule,

    //NG-Zorro
    NgZorroModule,
    JiraControlModule,
    SnowModule,

    // Service Worker
    ServiceWorkerModule.register('service-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    // Routing (sempre ultimo)
    AppRoutingModule
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
